import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class UpdateCompanyRequest extends GenericRequest {

    // CompanySave {
    //     id: number
    //     name: string
    //     nif: string
    //     contact_person: string
    //     phone: string
    //     email: string
    //     address: string
    //     ccc: string
    //     disabled: boolean
    //     document_schema_id: number
    //     document_schema_monthly_id: number
    //     user_email: string
    //     user_password: string
    //     user_plain_password: string
    // }
    companySave;

    constructor(id, companySave) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.COMPANY_ID, { id }));
        this.companySave = companySave;
    }

    overrideRequest() {
        return this.companySave;
    }
}



// WEBPACK FOOTER //
// ./src/app/company/ws/UpdateCompanyRequest.js